import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type PeoplePickerComponentState, type PeoplePickerConfig} from './types';

const domain = 'PEOPLE_PICKER';

export const {
    action: submit,
    success: submitSuccess,
    failed: submitFailed,
    aborted: submitAborted,
} = createAction(
    `${domain}/submit`,
    (
        config: PeoplePickerConfig,
        selectedChildren: PeoplePickerComponentState['selectedChildren'],
        selectedEmployees: PeoplePickerComponentState['selectedEmployees'],
    ) => ({config, selectedChildren, selectedEmployees}),
);
